import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Grid } from 'semantic-ui-react';
import { getFormSubmitErrors } from 'redux-form';
import PropTypes from 'prop-types';

import { Filter, Main } from 'Containers';
import { TitledCard, LoadingPage } from 'Components';
import { submitForm } from 'State/forms/actions';
import { errorToast, createToast, toastType } from 'Common/ToastHelper';
import { VENDOR_FORM_NAME } from 'Common/FormEnum';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { GenericEnum } from 'Common/Constants/Enumeration/CommonEnum';

import VendorForm from '../components/VendorForm';
import { vendorInitialValues, vendorSubmitValues } from './../helpers';
import {
  clearVendorData,
  fetchVendor,
  saveVendor,
  clearVendorErrorSuccess,
} from '../state/vendorDetails/actions';

class AddEditVendorContainer extends Component {
  static path = '/vendorsetup/:id';

  static propTypes = {
    vendorData: PropTypes.object.isRequired,
    formHasErrors: PropTypes.bool,
    fetching: PropTypes.bool.isRequired,
    submitted: PropTypes.bool.isRequired,
    submitError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    fetchError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    submitting: PropTypes.bool.isRequired,
    clearVendorErrorSuccess: PropTypes.func.isRequired,
    clearVendorData: PropTypes.func.isRequired,
    fetchVendor: PropTypes.func.isRequired,
    saveVendor: PropTypes.func.isRequired,
    submitForm: PropTypes.func.isRequired,
  };

  static defaultProps = {
    formHasErrors: false,
    submitError: null,
    fetchError: null,
  };

  componentDidMount() {
    const { id } = this.props.match.params;
    if (id !== '0') {
      this.props.fetchVendor(id);
    }
  }

  componentWillUnmount() {
    this.props.clearVendorData();
  }

  componentDidUpdate(prevProps) {
    const { clearVendorErrorSuccess } = this.props;
    if (errorToast(this.props, prevProps, 'submitError')) {
      clearVendorErrorSuccess();
    } else if (errorToast(this.props, prevProps, 'fetchError')) {
      clearVendorErrorSuccess();
    } else if (this.props.submitted && !prevProps.submitted) {
      createToast(
        toastType.success,
        'Success',
        'Distributor has been saved',
        true
      );
      clearVendorErrorSuccess();
    }
  }

  getRootUrl = () => {
    const { url } = this.props.match;
    return url.substring(0, url.lastIndexOf('/'));
  };

  onSaveClick = () => {
    this.props.scrollMainTo(0, 0);
    this.props.submitForm(VENDOR_FORM_NAME);
  };

  getMainProps = () => {
    const { submitting, isReadOnly, formHasErrors } = this.props;
    return {
      toolbox: {
        backButtonProps: { shown: true, path: this.getRootUrl() },
        rightButtons: [
          {
            content: 'Save',
            disabled: submitting || isReadOnly || formHasErrors,
            loading: submitting,
            onClick: this.onSaveClick,
          },
        ],
        shown: true,
      },
    };
  };

  handleMainSubmit = model => {
    return this.props.saveVendor(vendorSubmitValues(model));
  };

  render() {
    const { id } = this.props.match.params;
    const title = `Distributor - ${
      id === GenericEnum.ZeroString ? 'Add' : 'Edit'
    }`;

    const { vendorData, fetching } = this.props;
    return (
      <Fragment>
        {fetching && <LoadingPage />}
        <Filter title={title} />
        <Main {...this.getMainProps()} shouldNotUsePageWidth>
          <Grid>
            <Grid.Column>
              <Grid.Row>
                <TitledCard title={'Distributor Information'}>
                  <VendorForm
                    initialValues={
                      vendorData ? vendorInitialValues(vendorData) : {}
                    }
                    onSubmit={this.handleMainSubmit}
                  />
                </TitledCard>
              </Grid.Row>
            </Grid.Column>
          </Grid>
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const formErrors = getFormSubmitErrors(VENDOR_FORM_NAME)(state);
  const { vendorDetails } = state.VendorSetupState;
  ownProps.setPageLevelDirty(getIsDirty(VENDOR_FORM_NAME)(state));
  return {
    vendorData: vendorDetails.data,
    formHasErrors: formErrors ? Object.keys(formErrors).length > 0 : false,
    fetching: vendorDetails.fetching,
    submitted: vendorDetails.submitted,
    submitError: vendorDetails.submitError,
    fetchError: vendorDetails.fetchError,
    submitting: vendorDetails.submitting,
  };
};

const mapDispatchToProps = {
  clearVendorData,
  fetchVendor,
  saveVendor,
  submitForm,
  clearVendorErrorSuccess,
};

export const AddEditVendor = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AddEditVendorContainer)
);



// WEBPACK FOOTER //
// ./src/pages/inventory/vendorsetup/subpages/AddEditVendor.js